// Guards against infinite hard-reload loops after deploy / stale chunk recovery.

import buildGitSha from "../src/buildGitSha.js";

const SESSION_KEY = "frontend:staleChunkReload";
const PENDING_ACK_KEY = "frontend:pendingVersionAck";

/** Automatic stale-chunk recovery: one retry per window. */
const AUTO_RETRY_COOLDOWN_MS = 120_000;

/** User clicked "new version" reload: allow several tries while bundle catches up. */
const USER_RELOAD_MAX_ATTEMPTS = 6;
const USER_RELOAD_WINDOW_MS = 60_000;

export function runningFrontendVersion() {
  const version = buildGitSha;
  return typeof version === "string" && version && version !== "unknown" ? version : "unknown";
}

export function markFrontendReloadAttempt() {
  try {
    const now = Date.now();
    const v = runningFrontendVersion();
    let attempts = 1;
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      const prev = JSON.parse(raw);
      if (prev.v === v && now - prev.at < USER_RELOAD_WINDOW_MS) {
        attempts = (prev.attempts || 1) + 1;
      }
    }
    sessionStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ at: now, v, attempts }),
    );
  } catch {
    // ignore
  }
}

export function canAttemptFrontendReload() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return true;

    const { at, v, attempts = 1 } = JSON.parse(raw);
    const elapsed = Date.now() - at;
    const running = runningFrontendVersion();

    if (v !== running) return true;

    const userTriggered = Boolean(sessionStorage.getItem(PENDING_ACK_KEY));
    if (userTriggered) {
      if (elapsed > USER_RELOAD_WINDOW_MS) return true;
      return attempts < USER_RELOAD_MAX_ATTEMPTS;
    }

    return elapsed > AUTO_RETRY_COOLDOWN_MS;
  } catch {
    return true;
  }
}
